"use strict";

// Copyright 2019 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var _objectSpread = require("/codebuild/output/src2660572673/src/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");
var _asyncToGenerator = require("/codebuild/output/src2660572673/src/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _classCallCheck = require("/codebuild/output/src2660572673/src/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/codebuild/output/src2660572673/src/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoogleAuth = exports.CLOUD_SDK_CLIENT_ID = void 0;
var child_process_1 = require("child_process");
var fs = require("fs");
var gcpMetadata = require("gcp-metadata");
var os = require("os");
var path = require("path");
var crypto_1 = require("../crypto/crypto");
var transporters_1 = require("../transporters");
var computeclient_1 = require("./computeclient");
var idtokenclient_1 = require("./idtokenclient");
var envDetect_1 = require("./envDetect");
var jwtclient_1 = require("./jwtclient");
var refreshclient_1 = require("./refreshclient");
exports.CLOUD_SDK_CLIENT_ID = '764086051850-6qr4p6gpi6hn506pt8ejuq83di341hur.apps.googleusercontent.com';
var GoogleAuth = /*#__PURE__*/function () {
  function GoogleAuth(opts) {
    _classCallCheck(this, GoogleAuth);
    /**
     * Caches a value indicating whether the auth layer is running on Google
     * Compute Engine.
     * @private
     */
    this.checkIsGCE = undefined;
    // To save the contents of the JSON credential file
    this.jsonContent = null;
    this.cachedCredential = null;
    opts = opts || {};
    this._cachedProjectId = opts.projectId || null;
    this.keyFilename = opts.keyFilename || opts.keyFile;
    this.scopes = opts.scopes;
    this.jsonContent = opts.credentials || null;
    this.clientOptions = opts.clientOptions;
  }
  // Note:  this properly is only public to satisify unit tests.
  // https://github.com/Microsoft/TypeScript/issues/5228
  _createClass(GoogleAuth, [{
    key: "isGCE",
    get: function get() {
      return this.checkIsGCE;
    }
  }, {
    key: "getProjectId",
    value: function getProjectId(callback) {
      if (callback) {
        this.getProjectIdAsync().then(function (r) {
          return callback(null, r);
        }, callback);
      } else {
        return this.getProjectIdAsync();
      }
    }
  }, {
    key: "getProjectIdAsync",
    value: function getProjectIdAsync() {
      var _this = this;
      if (this._cachedProjectId) {
        return Promise.resolve(this._cachedProjectId);
      }
      // In implicit case, supports three environments. In order of precedence,
      // the implicit environments are:
      // - GCLOUD_PROJECT or GOOGLE_CLOUD_PROJECT environment variable
      // - GOOGLE_APPLICATION_CREDENTIALS JSON file
      // - Cloud SDK: `gcloud config config-helper --format json`
      // - GCE project ID from metadata server)
      if (!this._getDefaultProjectIdPromise) {
        // TODO: refactor the below code so that it doesn't mix and match
        // promises and async/await.
        this._getDefaultProjectIdPromise = new Promise(
        /*#__PURE__*/
        // eslint-disable-next-line no-async-promise-executor
        function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(resolve, reject) {
            var projectId;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.t2 = _this.getProductionProjectId();
                  if (_context.t2) {
                    _context.next = 6;
                    break;
                  }
                  _context.next = 5;
                  return _this.getFileProjectId();
                case 5:
                  _context.t2 = _context.sent;
                case 6:
                  _context.t1 = _context.t2;
                  if (_context.t1) {
                    _context.next = 11;
                    break;
                  }
                  _context.next = 10;
                  return _this.getDefaultServiceProjectId();
                case 10:
                  _context.t1 = _context.sent;
                case 11:
                  _context.t0 = _context.t1;
                  if (_context.t0) {
                    _context.next = 16;
                    break;
                  }
                  _context.next = 15;
                  return _this.getGCEProjectId();
                case 15:
                  _context.t0 = _context.sent;
                case 16:
                  projectId = _context.t0;
                  _this._cachedProjectId = projectId;
                  if (projectId) {
                    _context.next = 20;
                    break;
                  }
                  throw new Error('Unable to detect a Project Id in the current environment. \n' + 'To learn more about authentication and Google APIs, visit: \n' + 'https://cloud.google.com/docs/authentication/getting-started');
                case 20:
                  resolve(projectId);
                  _context.next = 26;
                  break;
                case 23:
                  _context.prev = 23;
                  _context.t3 = _context["catch"](0);
                  reject(_context.t3);
                case 26:
                case "end":
                  return _context.stop();
              }
            }, _callee, null, [[0, 23]]);
          }));
          return function (_x, _x2) {
            return _ref.apply(this, arguments);
          };
        }());
      }
      return this._getDefaultProjectIdPromise;
    }
  }, {
    key: "getApplicationDefault",
    value: function getApplicationDefault() {
      var optionsOrCallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      var options;
      if (typeof optionsOrCallback === 'function') {
        callback = optionsOrCallback;
      } else {
        options = optionsOrCallback;
      }
      if (callback) {
        this.getApplicationDefaultAsync(options).then(function (r) {
          return callback(null, r.credential, r.projectId);
        }, callback);
      } else {
        return this.getApplicationDefaultAsync(options);
      }
    }
  }, {
    key: "getApplicationDefaultAsync",
    value: function () {
      var _getApplicationDefaultAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var options,
          credential,
          projectId,
          isGCE,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              options = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
              if (!this.cachedCredential) {
                _context2.next = 7;
                break;
              }
              _context2.t0 = this.cachedCredential;
              _context2.next = 5;
              return this.getProjectIdAsync();
            case 5:
              _context2.t1 = _context2.sent;
              return _context2.abrupt("return", {
                credential: _context2.t0,
                projectId: _context2.t1
              });
            case 7:
              _context2.next = 9;
              return this._tryGetApplicationCredentialsFromEnvironmentVariable(options);
            case 9:
              credential = _context2.sent;
              if (!credential) {
                _context2.next = 17;
                break;
              }
              if (credential instanceof jwtclient_1.JWT) {
                credential.defaultScopes = this.defaultScopes;
                credential.scopes = this.scopes;
              }
              this.cachedCredential = credential;
              _context2.next = 15;
              return this.getProjectId();
            case 15:
              projectId = _context2.sent;
              return _context2.abrupt("return", {
                credential: credential,
                projectId: projectId
              });
            case 17:
              _context2.next = 19;
              return this._tryGetApplicationCredentialsFromWellKnownFile(options);
            case 19:
              credential = _context2.sent;
              if (!credential) {
                _context2.next = 27;
                break;
              }
              if (credential instanceof jwtclient_1.JWT) {
                credential.defaultScopes = this.defaultScopes;
                credential.scopes = this.scopes;
              }
              this.cachedCredential = credential;
              _context2.next = 25;
              return this.getProjectId();
            case 25:
              projectId = _context2.sent;
              return _context2.abrupt("return", {
                credential: credential,
                projectId: projectId
              });
            case 27:
              _context2.prev = 27;
              _context2.next = 30;
              return this._checkIsGCE();
            case 30:
              isGCE = _context2.sent;
              _context2.next = 37;
              break;
            case 33:
              _context2.prev = 33;
              _context2.t2 = _context2["catch"](27);
              _context2.t2.message = "Unexpected error determining execution environment: ".concat(_context2.t2.message);
              throw _context2.t2;
            case 37:
              if (isGCE) {
                _context2.next = 39;
                break;
              }
              throw new Error('Could not load the default credentials. Browse to https://cloud.google.com/docs/authentication/getting-started for more information.');
            case 39:
              // For GCE, just return a default ComputeClient. It will take care of
              // the rest.
              options.scopes = this.scopes || this.defaultScopes;
              this.cachedCredential = new computeclient_1.Compute(options);
              _context2.next = 43;
              return this.getProjectId();
            case 43:
              projectId = _context2.sent;
              return _context2.abrupt("return", {
                projectId: projectId,
                credential: this.cachedCredential
              });
            case 45:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[27, 33]]);
      }));
      function getApplicationDefaultAsync() {
        return _getApplicationDefaultAsync.apply(this, arguments);
      }
      return getApplicationDefaultAsync;
    }()
    /**
     * Determines whether the auth layer is running on Google Compute Engine.
     * @returns A promise that resolves with the boolean.
     * @api private
     */
  }, {
    key: "_checkIsGCE",
    value: function () {
      var _checkIsGCE2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(this.checkIsGCE === undefined)) {
                _context3.next = 4;
                break;
              }
              _context3.next = 3;
              return gcpMetadata.isAvailable();
            case 3:
              this.checkIsGCE = _context3.sent;
            case 4:
              return _context3.abrupt("return", this.checkIsGCE);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function _checkIsGCE() {
        return _checkIsGCE2.apply(this, arguments);
      }
      return _checkIsGCE;
    }()
    /**
     * Attempts to load default credentials from the environment variable path..
     * @returns Promise that resolves with the OAuth2Client or null.
     * @api private
     */
  }, {
    key: "_tryGetApplicationCredentialsFromEnvironmentVariable",
    value: function () {
      var _tryGetApplicationCredentialsFromEnvironmentVariable2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(options) {
        var credentialsPath;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              credentialsPath = process.env['GOOGLE_APPLICATION_CREDENTIALS'] || process.env['google_application_credentials'];
              if (!(!credentialsPath || credentialsPath.length === 0)) {
                _context4.next = 3;
                break;
              }
              return _context4.abrupt("return", null);
            case 3:
              _context4.prev = 3;
              return _context4.abrupt("return", this._getApplicationCredentialsFromFilePath(credentialsPath, options));
            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](3);
              _context4.t0.message = "Unable to read the credential file specified by the GOOGLE_APPLICATION_CREDENTIALS environment variable: ".concat(_context4.t0.message);
              throw _context4.t0;
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[3, 7]]);
      }));
      function _tryGetApplicationCredentialsFromEnvironmentVariable(_x3) {
        return _tryGetApplicationCredentialsFromEnvironmentVariable2.apply(this, arguments);
      }
      return _tryGetApplicationCredentialsFromEnvironmentVariable;
    }()
    /**
     * Attempts to load default credentials from a well-known file location
     * @return Promise that resolves with the OAuth2Client or null.
     * @api private
     */
  }, {
    key: "_tryGetApplicationCredentialsFromWellKnownFile",
    value: function () {
      var _tryGetApplicationCredentialsFromWellKnownFile2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(options) {
        var location, home, client;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              // First, figure out the location of the file, depending upon the OS type.
              location = null;
              if (this._isWindows()) {
                // Windows
                location = process.env['APPDATA'];
              } else {
                // Linux or Mac
                home = process.env['HOME'];
                if (home) {
                  location = path.join(home, '.config');
                }
              }
              // If we found the root path, expand it.
              if (location) {
                location = path.join(location, 'gcloud', 'application_default_credentials.json');
                if (!fs.existsSync(location)) {
                  location = null;
                }
              }
              // The file does not exist.
              if (location) {
                _context5.next = 5;
                break;
              }
              return _context5.abrupt("return", null);
            case 5:
              _context5.next = 7;
              return this._getApplicationCredentialsFromFilePath(location, options);
            case 7:
              client = _context5.sent;
              return _context5.abrupt("return", client);
            case 9:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function _tryGetApplicationCredentialsFromWellKnownFile(_x4) {
        return _tryGetApplicationCredentialsFromWellKnownFile2.apply(this, arguments);
      }
      return _tryGetApplicationCredentialsFromWellKnownFile;
    }()
    /**
     * Attempts to load default credentials from a file at the given path..
     * @param filePath The path to the file to read.
     * @returns Promise that resolves with the OAuth2Client
     * @api private
     */
  }, {
    key: "_getApplicationCredentialsFromFilePath",
    value: function () {
      var _getApplicationCredentialsFromFilePath2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(filePath) {
        var options,
          readStream,
          _args6 = arguments;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              options = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};
              if (!(!filePath || filePath.length === 0)) {
                _context6.next = 3;
                break;
              }
              throw new Error('The file path is invalid.');
            case 3:
              _context6.prev = 3;
              // Resolve path to actual file in case of symlink. Expect a thrown error
              // if not resolvable.
              filePath = fs.realpathSync(filePath);
              if (fs.lstatSync(filePath).isFile()) {
                _context6.next = 7;
                break;
              }
              throw new Error();
            case 7:
              _context6.next = 13;
              break;
            case 9:
              _context6.prev = 9;
              _context6.t0 = _context6["catch"](3);
              _context6.t0.message = "The file at ".concat(filePath, " does not exist, or it is not a file. ").concat(_context6.t0.message);
              throw _context6.t0;
            case 13:
              // Now open a read stream on the file, and parse it.
              readStream = fs.createReadStream(filePath);
              return _context6.abrupt("return", this.fromStream(readStream, options));
            case 15:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[3, 9]]);
      }));
      function _getApplicationCredentialsFromFilePath(_x5) {
        return _getApplicationCredentialsFromFilePath2.apply(this, arguments);
      }
      return _getApplicationCredentialsFromFilePath;
    }()
    /**
     * Create a credentials instance using the given input options.
     * @param json The input object.
     * @param options The JWT or UserRefresh options for the client
     * @returns JWT or UserRefresh Client with data
     */
  }, {
    key: "fromJSON",
    value: function fromJSON(json, options) {
      var client;
      if (!json) {
        throw new Error('Must pass in a JSON object containing the Google auth settings.');
      }
      options = options || {};
      if (json.type === 'authorized_user') {
        client = new refreshclient_1.UserRefreshClient(options);
      } else {
        options.scopes = this.scopes;
        client = new jwtclient_1.JWT(options);
        client.defaultScopes = this.defaultScopes;
      }
      client.fromJSON(json);
      return client;
    }
    /**
     * Return a JWT or UserRefreshClient from JavaScript object, caching both the
     * object used to instantiate and the client.
     * @param json The input object.
     * @param options The JWT or UserRefresh options for the client
     * @returns JWT or UserRefresh Client with data
     */
  }, {
    key: "_cacheClientFromJSON",
    value: function _cacheClientFromJSON(json, options) {
      var client;
      // create either a UserRefreshClient or JWT client.
      options = options || {};
      if (json.type === 'authorized_user') {
        client = new refreshclient_1.UserRefreshClient(options);
      } else {
        options.scopes = this.scopes;
        client = new jwtclient_1.JWT(options);
        client.defaultScopes = this.defaultScopes;
      }
      client.fromJSON(json);
      // cache both raw data used to instantiate client and client itself.
      this.jsonContent = json;
      this.cachedCredential = client;
      return this.cachedCredential;
    }
  }, {
    key: "fromStream",
    value: function fromStream(inputStream) {
      var optionsOrCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments.length > 2 ? arguments[2] : undefined;
      var options = {};
      if (typeof optionsOrCallback === 'function') {
        callback = optionsOrCallback;
      } else {
        options = optionsOrCallback;
      }
      if (callback) {
        this.fromStreamAsync(inputStream, options).then(function (r) {
          return callback(null, r);
        }, callback);
      } else {
        return this.fromStreamAsync(inputStream, options);
      }
    }
  }, {
    key: "fromStreamAsync",
    value: function fromStreamAsync(inputStream, options) {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        if (!inputStream) {
          throw new Error('Must pass in a stream containing the Google auth settings.');
        }
        var s = '';
        inputStream.setEncoding('utf8').on('error', reject).on('data', function (chunk) {
          return s += chunk;
        }).on('end', function () {
          try {
            try {
              var data = JSON.parse(s);
              var r = _this2._cacheClientFromJSON(data, options);
              return resolve(r);
            } catch (err) {
              // If we failed parsing this.keyFileName, assume that it
              // is a PEM or p12 certificate:
              if (!_this2.keyFilename) throw err;
              var client = new jwtclient_1.JWT(_objectSpread(_objectSpread({}, _this2.clientOptions), {}, {
                keyFile: _this2.keyFilename
              }));
              _this2.cachedCredential = client;
              return resolve(client);
            }
          } catch (err) {
            return reject(err);
          }
        });
      });
    }
    /**
     * Create a credentials instance using the given API key string.
     * @param apiKey The API key string
     * @param options An optional options object.
     * @returns A JWT loaded from the key
     */
  }, {
    key: "fromAPIKey",
    value: function fromAPIKey(apiKey, options) {
      options = options || {};
      var client = new jwtclient_1.JWT(options);
      client.fromAPIKey(apiKey);
      return client;
    }
    /**
     * Determines whether the current operating system is Windows.
     * @api private
     */
  }, {
    key: "_isWindows",
    value: function _isWindows() {
      var sys = os.platform();
      if (sys && sys.length >= 3) {
        if (sys.substring(0, 3).toLowerCase() === 'win') {
          return true;
        }
      }
      return false;
    }
    /**
     * Run the Google Cloud SDK command that prints the default project ID
     */
  }, {
    key: "getDefaultServiceProjectId",
    value: function () {
      var _getDefaultServiceProjectId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", new Promise(function (resolve) {
                child_process_1.exec('gcloud config config-helper --format json', function (err, stdout) {
                  if (!err && stdout) {
                    try {
                      var projectId = JSON.parse(stdout).configuration.properties.core.project;
                      resolve(projectId);
                      return;
                    } catch (e) {
                      // ignore errors
                    }
                  }
                  resolve(null);
                });
              }));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function getDefaultServiceProjectId() {
        return _getDefaultServiceProjectId.apply(this, arguments);
      }
      return getDefaultServiceProjectId;
    }()
    /**
     * Loads the project id from environment variables.
     * @api private
     */
  }, {
    key: "getProductionProjectId",
    value: function getProductionProjectId() {
      return process.env['GCLOUD_PROJECT'] || process.env['GOOGLE_CLOUD_PROJECT'] || process.env['gcloud_project'] || process.env['google_cloud_project'];
    }
    /**
     * Loads the project id from the GOOGLE_APPLICATION_CREDENTIALS json file.
     * @api private
     */
  }, {
    key: "getFileProjectId",
    value: function () {
      var _getFileProjectId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var creds, r;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!this.cachedCredential) {
                _context8.next = 2;
                break;
              }
              return _context8.abrupt("return", this.cachedCredential.projectId);
            case 2:
              if (!this.keyFilename) {
                _context8.next = 8;
                break;
              }
              _context8.next = 5;
              return this.getClient();
            case 5:
              creds = _context8.sent;
              if (!(creds && creds.projectId)) {
                _context8.next = 8;
                break;
              }
              return _context8.abrupt("return", creds.projectId);
            case 8:
              _context8.next = 10;
              return this._tryGetApplicationCredentialsFromEnvironmentVariable();
            case 10:
              r = _context8.sent;
              if (!r) {
                _context8.next = 15;
                break;
              }
              return _context8.abrupt("return", r.projectId);
            case 15:
              return _context8.abrupt("return", null);
            case 16:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getFileProjectId() {
        return _getFileProjectId.apply(this, arguments);
      }
      return getFileProjectId;
    }()
    /**
     * Gets the Compute Engine project ID if it can be inferred.
     */
  }, {
    key: "getGCEProjectId",
    value: function () {
      var _getGCEProjectId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var r;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return gcpMetadata.project('project-id');
            case 3:
              r = _context9.sent;
              return _context9.abrupt("return", r);
            case 7:
              _context9.prev = 7;
              _context9.t0 = _context9["catch"](0);
              return _context9.abrupt("return", null);
            case 10:
            case "end":
              return _context9.stop();
          }
        }, _callee9, null, [[0, 7]]);
      }));
      function getGCEProjectId() {
        return _getGCEProjectId.apply(this, arguments);
      }
      return getGCEProjectId;
    }()
  }, {
    key: "getCredentials",
    value: function getCredentials(callback) {
      if (callback) {
        this.getCredentialsAsync().then(function (r) {
          return callback(null, r);
        }, callback);
      } else {
        return this.getCredentialsAsync();
      }
    }
  }, {
    key: "getCredentialsAsync",
    value: function () {
      var _getCredentialsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var credential, isGCE, data;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.getClient();
            case 2:
              if (!this.jsonContent) {
                _context10.next = 5;
                break;
              }
              credential = {
                client_email: this.jsonContent.client_email,
                private_key: this.jsonContent.private_key
              };
              return _context10.abrupt("return", credential);
            case 5:
              _context10.next = 7;
              return this._checkIsGCE();
            case 7:
              isGCE = _context10.sent;
              if (isGCE) {
                _context10.next = 10;
                break;
              }
              throw new Error('Unknown error.');
            case 10:
              _context10.next = 12;
              return gcpMetadata.instance({
                property: 'service-accounts/',
                params: {
                  recursive: 'true'
                }
              });
            case 12:
              data = _context10.sent;
              if (!(!data || !data.default || !data.default.email)) {
                _context10.next = 15;
                break;
              }
              throw new Error('Failure from metadata server.');
            case 15:
              return _context10.abrupt("return", {
                client_email: data.default.email
              });
            case 16:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function getCredentialsAsync() {
        return _getCredentialsAsync.apply(this, arguments);
      }
      return getCredentialsAsync;
    }()
    /**
     * Automatically obtain a client based on the provided configuration.  If no
     * options were passed, use Application Default Credentials.
     */
  }, {
    key: "getClient",
    value: function () {
      var _getClient = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(options) {
        var filePath, stream;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (!options) {
                _context11.next = 2;
                break;
              }
              throw new Error('Passing options to getClient is forbidden in v5.0.0. Use new GoogleAuth(opts) instead.');
            case 2:
              if (this.cachedCredential) {
                _context11.next = 16;
                break;
              }
              if (!this.jsonContent) {
                _context11.next = 7;
                break;
              }
              this._cacheClientFromJSON(this.jsonContent, this.clientOptions);
              _context11.next = 16;
              break;
            case 7:
              if (!this.keyFilename) {
                _context11.next = 14;
                break;
              }
              filePath = path.resolve(this.keyFilename);
              stream = fs.createReadStream(filePath);
              _context11.next = 12;
              return this.fromStreamAsync(stream, this.clientOptions);
            case 12:
              _context11.next = 16;
              break;
            case 14:
              _context11.next = 16;
              return this.getApplicationDefaultAsync(this.clientOptions);
            case 16:
              return _context11.abrupt("return", this.cachedCredential);
            case 17:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function getClient(_x6) {
        return _getClient.apply(this, arguments);
      }
      return getClient;
    }()
    /**
     * Creates a client which will fetch an ID token for authorization.
     * @param targetAudience the audience for the fetched ID token.
     * @returns IdTokenClient for making HTTP calls authenticated with ID tokens.
     */
  }, {
    key: "getIdTokenClient",
    value: function () {
      var _getIdTokenClient = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(targetAudience) {
        var client;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return this.getClient();
            case 2:
              client = _context12.sent;
              if ('fetchIdToken' in client) {
                _context12.next = 5;
                break;
              }
              throw new Error('Cannot fetch ID token in this environment, use GCE or set the GOOGLE_APPLICATION_CREDENTIALS environment variable to a service account credentials JSON file.');
            case 5:
              return _context12.abrupt("return", new idtokenclient_1.IdTokenClient({
                targetAudience: targetAudience,
                idTokenProvider: client
              }));
            case 6:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function getIdTokenClient(_x7) {
        return _getIdTokenClient.apply(this, arguments);
      }
      return getIdTokenClient;
    }()
    /**
     * Automatically obtain application default credentials, and return
     * an access token for making requests.
     */
  }, {
    key: "getAccessToken",
    value: function () {
      var _getAccessToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var client;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return this.getClient();
            case 2:
              client = _context13.sent;
              _context13.next = 5;
              return client.getAccessToken();
            case 5:
              return _context13.abrupt("return", _context13.sent.token);
            case 6:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function getAccessToken() {
        return _getAccessToken.apply(this, arguments);
      }
      return getAccessToken;
    }()
    /**
     * Obtain the HTTP headers that will provide authorization for a given
     * request.
     */
  }, {
    key: "getRequestHeaders",
    value: function () {
      var _getRequestHeaders = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(url) {
        var client;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return this.getClient();
            case 2:
              client = _context14.sent;
              return _context14.abrupt("return", client.getRequestHeaders(url));
            case 4:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function getRequestHeaders(_x8) {
        return _getRequestHeaders.apply(this, arguments);
      }
      return getRequestHeaders;
    }()
    /**
     * Obtain credentials for a request, then attach the appropriate headers to
     * the request options.
     * @param opts Axios or Request options on which to attach the headers
     */
  }, {
    key: "authorizeRequest",
    value: function () {
      var _authorizeRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(opts) {
        var url, client, headers;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              opts = opts || {};
              url = opts.url || opts.uri;
              _context15.next = 4;
              return this.getClient();
            case 4:
              client = _context15.sent;
              _context15.next = 7;
              return client.getRequestHeaders(url);
            case 7:
              headers = _context15.sent;
              opts.headers = Object.assign(opts.headers || {}, headers);
              return _context15.abrupt("return", opts);
            case 10:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function authorizeRequest(_x9) {
        return _authorizeRequest.apply(this, arguments);
      }
      return authorizeRequest;
    }()
    /**
     * Automatically obtain application default credentials, and make an
     * HTTP request using the given options.
     * @param opts Axios request options for the HTTP request.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(opts) {
        var client;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return this.getClient();
            case 2:
              client = _context16.sent;
              return _context16.abrupt("return", client.request(opts));
            case 4:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function request(_x10) {
        return _request.apply(this, arguments);
      }
      return request;
    }()
    /**
     * Determine the compute environment in which the code is running.
     */
  }, {
    key: "getEnv",
    value: function getEnv() {
      return envDetect_1.getEnv();
    }
    /**
     * Sign the given data with the current private key, or go out
     * to the IAM API to sign it.
     * @param data The data to be signed.
     */
  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(data) {
        var client, crypto, _sign2, projectId, creds, url, res;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return this.getClient();
            case 2:
              client = _context17.sent;
              crypto = crypto_1.createCrypto();
              if (!(client instanceof jwtclient_1.JWT && client.key)) {
                _context17.next = 9;
                break;
              }
              _context17.next = 7;
              return crypto.sign(client.key, data);
            case 7:
              _sign2 = _context17.sent;
              return _context17.abrupt("return", _sign2);
            case 9:
              _context17.next = 11;
              return this.getProjectId();
            case 11:
              projectId = _context17.sent;
              if (projectId) {
                _context17.next = 14;
                break;
              }
              throw new Error('Cannot sign data without a project ID.');
            case 14:
              _context17.next = 16;
              return this.getCredentials();
            case 16:
              creds = _context17.sent;
              if (creds.client_email) {
                _context17.next = 19;
                break;
              }
              throw new Error('Cannot sign data without `client_email`.');
            case 19:
              url = "https://iamcredentials.googleapis.com/v1/projects/-/serviceAccounts/".concat(creds.client_email, ":signBlob");
              _context17.next = 22;
              return this.request({
                method: 'POST',
                url: url,
                data: {
                  payload: crypto.encodeBase64StringUtf8(data)
                }
              });
            case 22:
              res = _context17.sent;
              return _context17.abrupt("return", res.data.signedBlob);
            case 24:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function sign(_x11) {
        return _sign.apply(this, arguments);
      }
      return sign;
    }()
  }]);
  return GoogleAuth;
}();
exports.GoogleAuth = GoogleAuth;
/**
 * Export DefaultTransporter as a static property of the class.
 */
GoogleAuth.DefaultTransporter = transporters_1.DefaultTransporter;